import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import NewFinCompra from 'src/pages/NewFinCompra';
import FinProcesoInfo from 'src/pages/NewFinCompra/FinProcesoInfo';
import NewPreviewProducto from 'src/pages/PreviewProducto/PreviewProducto';
import GenerarUrlPTP from 'src/pages/Redirects/GenerarUrlPTP';
import PtpPagoSuscripcion from 'src/pages/Redirects/PtpPagoSuscripcion';
import ErrorPage from './pages/ErrorPage';
import ExtraDataForm from './pages/ExtraDataForm';
import HomePage from './pages/Home';
import Home from './pages/Home/Home2';
import IngresarPoliza from './pages/IngresarPoliza';
import FirmarPolizaEvicertia from './pages/IngresarPoliza/FirmarPolizaEvicertia';
import FirmarCertificado from './pages/IngresarPoliza/FirmarCertificado';
import Login from './pages/Login';
import VerificarTokenPago from './pages/NewPaginaCompra/VerificarTokenPago';
import NotFound from './pages/NotFound';
import PaginaCompra from './pages/PaginaCompra';
import PaginaResumen from './pages/PaginaCompra/PaginaResumen';
import PaginaPago from './pages/PaginaPago';
import PtpMontoMinimoFromCorreo from './pages/Redirects/PtpMontoMinimoFromCorreo';
import PtpPagoUnico from './pages/Redirects/PtpPagoUnico';
import PtpPrimerPagoSuscripcion from './pages/Redirects/PtpPrimerPagoSuscripcion';
import RegistroTitularPage from './pages/Resgistro';
import ListadoPagos from './pages/ListadoPagos/ListadoPagos'
import CambioSuscripcionPtp from './pages/CambioSuscripcionPtp'
import FinCambioSuscripcion from './pages/CambioSuscripcionPtp/FinCambioSuscripcion'
import LoadingPage from './pages/LoadingPage';
const HistorialPagosPtp = React.lazy(() => import('./pages/HistorialPagos/HistorialPagosPtp'));
const advancedMatching = {
  em: "testlibelulasoft@gmail.com",
  ct: 'string',
  country: 'string',
  db: 'string',
  fn: 'string',
  ge: 'string',
  ln: 'string',
  ph: 'string',
  st: 'string',
  zp: 'string',
}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: true, // enable logs
};
const Routes = () => {
  React.useEffect(() => {
    ReactPixel.init('370679938158447', advancedMatching, options);
  }, [])
  ReactPixel.pageView();
  ReactPixel.trackCustom('ingresos', { currency: "USD", value: 30.00 })

  return (
    <React.Suspense fallback={<LoadingWrapper loading={true} />}>
      <Switch>
        {/*V4 Routes */}
        <Route exact path="/newHome/:idCotizacion" component={HomePage} />
        <Route exact path="/home/:idUsuario/:parametros" component={Home} />
        <Route exact path="/preview/:idCotizacion/:idProducto" component={NewPreviewProducto} />
        <Route exact path="/error/:idCotizacion" component={ErrorPage} />
        <Route exact path="/newRegistro/:idCotizacion" component={RegistroTitularPage} />
        <Route exact path="/newRegistro/:idCotizacion/:update" component={RegistroTitularPage} />
        <Route exact path="/newPaginaCompra/:idCotizacion" component={PaginaCompra} />
        <Route exact path="/paginaResumen/:idCotizacion" component={PaginaResumen} />
        <Route exact path="/paginaPago/:idCotizacion" component={PaginaPago} />

        {/*V3 Routes */}
        <Route exact path="/login/:canal/:empBroker/:empAplica" component={Login} />
        <Route exact path="/finproceso/:idCotizacion" component={NewFinCompra} />
        <Route exact path="/finprocesoinfo/:idCotizacion/:result" component={FinProcesoInfo} />
        <Route exact path="/ingresarPoliza/:idCotizacion" component={IngresarPoliza} />
        <Route
          path="/firmarPolizaEvicertia/:idCotizacion/:idPoliza"
          component={FirmarPolizaEvicertia}
          exact
        />
        <Route
          path="/firmarCertificadoEvicertia/:idCotizacion"
          component={FirmarPolizaEvicertia}
          exact
        />
        <Route
          path="/firmarCertificado/:idCotizacion"
          component={FirmarCertificado}
          exact
        />
        <Route
          path="/verificarTokenPago/:idCotizacion/:idPoliza?"
          component={VerificarTokenPago}
          exact
        />
        {/*ESTA ES LA PAGINA FINAL*/}
        <Route exact path="/newFinCompra/:idCotizacion" component={NewFinCompra} />
        {/*ESTA PAGINA SIRVE PARA HACER LA VALIDACION DEL PAGO, NO SE PUEDE CAMBIAR PORQUE EN EL MIDDLEWARE SE USAR CON ESE NOMBRE :/*/}

        <Route exact path="/place-to-pay/:idCotizacion/" component={GenerarUrlPTP} />
        <Route exact path="/finCompra/:idCotizacion/" component={PtpPagoUnico} />
        <Route exact path="/final-cotizacion/" component={PtpPagoUnico} />
        <Route exact path="/fin-suscripcion/:idCotizacion/:idSuscripcion" component={PtpPagoSuscripcion} />
        <Route exact path="/primer-pago-suscripcion/:idCotizacion/:idSuscripcion" component={PtpPrimerPagoSuscripcion} />
        {/* <Route path="/fin-suscripcion-correo/:idCotizacion" component={PtpPagoSuscripcionFromCorreo} exact /> */}
        <Route exact path="/ptp-monto-minimo-suscripcion/:idCotizacion/:idSuscripcion" component={PtpMontoMinimoFromCorreo} />
        <Route exact path="/extra-data-form/:idCotizacion" component={ExtraDataForm} />
        <Route exact path="/listado-pago/:ref/:empresa" component={ListadoPagos} />
        <Route exact path="/cambiosuscripcionptp/:idCotizacion" component={CambioSuscripcionPtp} />
        <Route exact path="/fin-cambiosuscripcion/:idCotizacion/:idSuscripcion" component={FinCambioSuscripcion} />
        <Route exact path="/historial-pagos-ptp" component={HistorialPagosPtp} />
        <Route exact path="/loading" component={LoadingPage} />
        <Route path="/*" component={NotFound} />
      </Switch>
    </React.Suspense>
  );
};

export default Routes;